<div class="markdown-block">
  <app-html [markdownText]="markdownBlock.markdown"></app-html>
</div>